import RelativeDateFormat from '../src/RelativeDateFormat';
export { RelativeDateFormat };
